import { CountryCodes } from "@/utils/constants";
import { DateType, getInternationalDateFormat, transformToDate } from "@/utils/dates";
import { DateTime } from "luxon";

export const useDates = () => {
  const countryCode = CountryCodes.US;

  const { locale, shortDateFormat, fullDateFormat } = getInternationalDateFormat(countryCode);

  // Use this function to get the ISO date string which can be passed to the server
  const toISODatetime = (date?: DateType | null) => transformToDate(date)?.toISO()?.toString() ?? "";

  const getLocalTime = (locale: string) => {
    return DateTime.local().setLocale(locale);
  };
  const getDateIsToday = (date?: DateType | null) => {
    const transformedDate = transformToDate(date);

    const startOfTransformedDate = transformedDate?.startOf("day");

    const startOfLuxonLocalTime = getLocalTime(locale).startOf("day");

    return startOfTransformedDate?.hasSame(startOfLuxonLocalTime, "day");
  };

  const formatDateToShortDate = (date?: DateType | null) =>
    getDateIsToday(date)
      ? `${transformToDate(date)?.toLocaleString(DateTime.DATE_SHORT, { locale }) ?? ""}, Today`
      : (transformToDate(date)?.toLocaleString(DateTime.DATE_SHORT, { locale }) ?? "");

  const formatDateToShortDateTime = (date?: DateType | null) =>
    getDateIsToday(date)
      ? `${transformToDate(date)?.toLocaleString(DateTime.TIME_24_SIMPLE, { locale }) ?? ""}, Today`
      : (transformToDate(date)?.toLocaleString(DateTime.DATETIME_SHORT, { locale }) ?? "");

  const formatToDateTime = (date?: DateType | null) =>
    transformToDate(date)?.toLocaleString(
      { hour: "2-digit", minute: "2-digit", hourCycle: "h23", weekday: "long", month: "long", day: "2-digit" },
      { locale },
    ) ?? "";

  const formatToFullDateTime = (date?: DateType | null) => transformToDate(date)?.toFormat(fullDateFormat, { locale }) ?? "";

  return {
    transformToDate,
    toISODatetime,
    shortDateFormat,
    formatDateToShortDateTime,
    formatToDateTime,
    formatToFullDateTime,
    formatDateToShortDate,
  };
};
